import React from 'react';
import { useIntl } from 'react-intl';

import { FontSizePropKey, useCurrentTheme } from 'app/shared/theme';
import {
  SOFAR_MOBILE_TERMS_URL,
  SOFAR_PRIVACY_POLICY_URL,
} from 'app/shared/utils/siteUrls';
import { NavigationLink, Typography } from 'app/shared/components/atoms';

interface Props {
  hasBackgroundColor: boolean;
  color?: string;
  fontSize?: FontSizePropKey;
}

export const SmsMarketingDisclaimer: React.FC<
  React.PropsWithChildren<Props>
> = ({ hasBackgroundColor, color, fontSize = 'fontSize50' }) => {
  const { colors } = useCurrentTheme();
  const { formatMessage } = useIntl();

  const smsMarketingDisclaimerColor = color
    ? color
    : hasBackgroundColor
      ? colors.primary.black.base
      : colors.primary.black.light;

  return (
    <Typography
      fontSize={fontSize}
      color={smsMarketingDisclaimerColor}
      data-qaid="sms-marketing-disclaimer"
    >
      {formatMessage({ id: 'smsSignUp.disclaimerPart1' })}
      <NavigationLink
        textDecoration="underline !important"
        href={SOFAR_PRIVACY_POLICY_URL}
        fontSize={fontSize}
        variant="secondary"
        data-qaid="sms-marketing-disclaimer-privacy-policy-link"
      >
        {formatMessage({ id: 'smsSignUp.disclaimerPrivacyPolicy' })}
      </NavigationLink>
      {' & '}
      <NavigationLink
        textDecoration="underline !important"
        href={SOFAR_MOBILE_TERMS_URL}
        fontSize={fontSize}
        variant="secondary"
        data-qaid="sms-marketing-disclaimer-terms-link"
      >
        {formatMessage({ id: 'smsSignUp.disclaimerTerms' })}
      </NavigationLink>
      .
    </Typography>
  );
};
